var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeicon9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 27,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.3327C21 18.8077 16.52 24.8627 10.5 26.3327C4.48 24.8627 0 18.8077 0 12.3327V5.33268L10.5 0.666016L21 5.33268V12.3327ZM10.5 23.9993C14.875 22.8327 18.6667 17.6293 18.6667 12.5893V6.84935L10.5 3.20935L2.33333 6.84935V12.5893C2.33333 17.6293 6.125 22.8327 10.5 23.9993ZM13.7667 12.3327V10.5827C13.7667 8.94935 12.1333 7.66602 10.5 7.66602C8.86667 7.66602 7.23333 8.94935 7.23333 10.5827V12.3327C6.53333 12.3327 5.83333 13.0327 5.83333 13.7327V17.816C5.83333 18.6327 6.53333 19.3327 7.23333 19.3327H13.65C14.4667 19.3327 15.1667 18.6327 15.1667 17.9327V13.8493C15.1667 13.0327 14.4667 12.3327 13.7667 12.3327ZM12.25 12.3327H8.75V10.5827C8.75 9.64935 9.56667 9.06602 10.5 9.06602C11.4333 9.06602 12.25 9.64935 12.25 10.5827V12.3327Z",
    fill: "#D40033"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeicon9);
export default __webpack_public_path__ + "static/media/homeicon9.f1e1d7336d0415dffad346dbef5cf6b3.svg";
export { ForwardRef as ReactComponent };